import React from 'react'

//import LABEL from '../../../../business-const/Label/Label'

//import {
//    COLOR
//} from '../../../../business-const/Color/Color'

//import {
//    GridItem11,
//    GridItem12,
//} from '../../../../business-components/Grid/Grid'

//import {
//    ChartPadrao
//} from '../../../../business-components/Chart/Chart'

import {
    formataValor
} from '../../../business-components/Formata/Formata'

import {
    round
} from '../../../business-components/round/round'

//import {
//    CardGridEstudoPadrao,
//} from '../estudo-form/EstudoComp'
import DiagnosticoAposentadoriaIndependenciaFinanceiraChart from './DiagnosticoAposentadoriaIndependenciaFinanceiraChart'



const DiagnosticoAposentadoriaIndependenciaFinanceiraPrimeiraReuniaoChart = ( { values, setFieldValue, estudo, report,
    popup, moreLessList } ) => {

    return (
        <DiagnosticoAposentadoriaIndependenciaFinanceiraChart
            values={values}
            setFieldValue={setFieldValue}
            estudo={estudo}
            graficoIndependenciaFinanceiraSituacaoAtualSuperavit={estudo.current.graficoIndependenciaFinanceiraPrimeiraReuniaoSituacaoRealSuperavit}
            graficoIndependenciaFinanceiraSituacaoAtualDeficit={estudo.current.graficoIndependenciaFinanceiraPrimeiraReuniaoSituacaoRealDeficit}
            valorRetiradaMensalMaximaConsumirReservaAposentadoria={values.retiradaMensalMaximaConsumirReservaAposentadoria}
            graficoIndependenciaFinanceiraConsumirReservaAposentadoria={
                estudo.current.graficoIndependenciaFinanceiraPrimeiraReuniaoConsumirRecursosFinanceiros
            }
            valorRetiradaMensalMaximaPreservarReservaAposentadoria={values.retiradaMensalMaximaPreservarReservaAposentadoria}
            graficoIndependenciaFinanceiraPreservarReservaAposentadoria={
                estudo.current.graficoIndependenciaFinanceiraPrimeiraReuniaoPreservarRecursosFinanceiros
            }
            valorPresenteDeficitSimulacaoMensal={values.aporteMensalAdicionalConsumirReservaAposentadoria}
            graficoIndependenciaFinanceiraSituacaoIdeal={estudo.current.graficoIndependenciaFinanceiraPrimeiraReuniaoSituacaoIdeal}
            valorAporteMensalPreservarReservaAposentadoria={values.aporteMensalAdicionalPreservarReservaAposentadoria}
            graficoIndependenciaFinanceiraViverRentabilidade={estudo.current.graficoIndependenciaFinanceiraPrimeiraReuniaoViverRentabilidade}
            valorPresenteDeficitReservaInicioAposentadoria={values.aporteMensalAdicionalConsumirReservaAposentadoria}
            valorDepositoUnicoManterPadraoVida={values.aporteUnicoAdicionalConsumirReservaAposentadoria}
            valorDepositoUnicoViverRentabilidade={values.aporteUnicoAdicionalPreservarReservaAposentadoria}
            necessidadeAposentadoria={formataValor(round(values.retiradaMensalDepoisAposentarCliente, 2), 2)}
            necessidadeAposentadoriaLimiteReserva={formataValor(round(values.retiradaMensalDepoisAposentarCliente, 2), 2)}
            valorDepositoViverRentabilidadeSaldoInicioAposentadoria={values.depositoViverRentabilidadeSaldoInicioAposentadoria}
            valorRetiradaMaximaPreservarRecursosFinanceirosSaldoInicioAposentadoria={
                values.retiradaMaximaPreservarRecursosFinanceirosSaldoInicioAposentadoria
            }
            //valorSaldoFinalSituacaoAtual={values.saldoFinalSituacaoAtual}
            valorPresenteReservaInicioAposentadoria={values.valorPresenteReservaInicioAposentadoriaPrimeiraReuniao}
            valorPresenteNecessidadesInicioAposentadoria={values.valorPresenteNecessidadesInicioAposentadoriaPrimeiraReuniao}
            report={report}
            popup={popup}
            simulacaoFinanceira={true}
            naoExibirCapacidadePoupanca={false}
            naoExibirGrafico={false}
            moreLessList={moreLessList}
            aiFT={false}
        />
    )

    //const DiagnosticoAposentadoriaIndependenciaFinanceiraPrimeiraReuniao = ( props ) => {

        //const series = []

        //const paletaCoresEspecifica = []

        //series.push(
        //    {
        //        name: LABEL.situacaoRealSuperavit,
        //        type: 'area',
        //        data: estudo.current.graficoIndependenciaFinanceiraPrimeiraReuniaoSituacaoRealSuperavit,
        //    },
        //)

        //paletaCoresEspecifica.push(
        //    COLOR().corChartPadraoVerde
        //)

        //series.push(
        //    {
        //        name: LABEL.situacaoRealDeficit,
        //        type: 'area',
        //        data: estudo.current.graficoIndependenciaFinanceiraPrimeiraReuniaoSituacaoRealDeficit,
        //    },
        //)

        //paletaCoresEspecifica.push(
        //    COLOR().corChartPadraoVermelho
        //)
        
        //if (values.retiradaMensalMaximaConsumirReservaAposentadoria !== 0) {
        //    series.push(
        //        {
        //            name: LABEL.retiradaMensalMaximaConsumirReserva.replace('$1$',
        //                formataValor(values.retiradaMensalMaximaConsumirReservaAposentadoria, 2)),
        //            type: 'line',
        //            data: estudo.current.graficoIndependenciaFinanceiraPrimeiraReuniaoConsumirRecursosFinanceiros,
        //        },
        //    )

        //    paletaCoresEspecifica.push(
        //        COLOR().corChartPadraoConsumirReservaSemNovosAportes,
        //    )
        //}

        //if (values.retiradaMensalMaximaPreservarReservaAposentadoria !== 0) {
        //    series.push(
        //        {
        //            name: LABEL.retiradaMensalMaximaPreservarReserva.replace('$1$',
        //                formataValor(values.retiradaMensalMaximaPreservarReservaAposentadoria, 2)),
        //            type: 'line',
        //            data: estudo.current.graficoIndependenciaFinanceiraPrimeiraReuniaoPreservarRecursosFinanceiros,
        //        },
        //    )

        //    paletaCoresEspecifica.push(
        //        COLOR().corChartPadraoManterReservaSemNovosAportes,
        //    )
        //}

        //if (values.aporteMensalAdicionalConsumirReservaAposentadoria !== 0) {

        //    series.push(
        //        {
        //           name: LABEL.aporteMensalConsumirReserva.replace('$1$',
        //                formataValor(values.aporteMensalAdicionalConsumirReservaAposentadoria, 2)),
        //            type: 'line',
        //            data: estudo.current.graficoIndependenciaFinanceiraPrimeiraReuniaoSituacaoIdeal,
        //        },
        //    )
        
        //    paletaCoresEspecifica.push(
        //        COLOR().corChartPadraoConsumirReservaManterPadraoVida,
        //    )
        //}

        //if (values.aporteMensalAdicionalPreservarReservaAposentadoria !== 0) {

        //    series.push(
        //        {
        //            name: LABEL.aporteMensalPreservarReserva.replace('$1$',
        //                formataValor(values.aporteMensalAdicionalPreservarReservaAposentadoria, 2)),
        //            type: 'line',
        //            data: estudo.current.graficoIndependenciaFinanceiraPrimeiraReuniaoViverRentabilidade,
        //        },
        //    )
        
        //    paletaCoresEspecifica.push(
        //        COLOR().corChartPadraoManterReservaManterPadraoVida,
        //    )
        //}

        //const categories = estudo.current.graficoIdadesGraficos

        //const GridGrafico = report && !popup ? GridItem12 : GridItem11

        //return (
        //    <div
        //        {...props}
        //    >
        //        <GridGrafico>
        //            <ChartPadrao
        //                titleText={popup ? '' : LABEL.diagnosticoAposentadoriaIndependenciaFinanceira}
        //                type="bar"
        //                series={series}
        //                height={popup ? 480 : 550}
        //                stacked={false}
        //                categories={categories}
        //                paletaCores={paletaCoresEspecifica}
        //                notInverseOrder={false}
        //                //legendFixedEnabled={true}
        //                toolTipX={true}
        //                toolTipXTotal={false}
        //                report={report}
        //                formatoReport={values.formatoReport}
        //            />
        //        </GridGrafico>
        //    </div>
        //)
    //}

    //return (
    //    <GridItem12>
    //        {report
    //            ?
    //                <DiagnosticoAposentadoriaIndependenciaFinanceiraPrimeiraReuniao
    //                    className='mt-2'
    //                />
    //            :
    //                
    //                <CardGridEstudoPadrao
    //                    label={LABEL.diagnosticoAposentadoriaIndependenciaFinanceira}
    //                    component={
    //                        <DiagnosticoAposentadoriaIndependenciaFinanceiraPrimeiraReuniao/>
    //                    }
    //                    overflowX={false}
    //                />
    //        }
    //    </GridItem12>
    //)
}

export default DiagnosticoAposentadoriaIndependenciaFinanceiraPrimeiraReuniaoChart